import {
  FormControl as MaterialFormControl,
  FormControlLabel as MaterialFormControlLabel,
  FormControlLabelProps,
  FormControlProps,
  FormHelperTextProps,
  FormLabel,
  RadioGroup as MaterialRadioGroup,
  RadioGroupProps as MaterialRadioGroupProps,
} from '@mui/material';
import React from 'react';

import { FormHelperText } from '../FormHelperText/FormHelperText';

export interface RadioGroupProps extends MaterialRadioGroupProps {
  legend?: string;
  label?: string;
  row?: boolean;
  children?: React.ReactNode;
  locked?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: FormHelperTextProps['children'];
}

export interface RadioProps extends FormControlLabelProps {
  children?: React.ReactElement;
}

/**
 * The RadioGroup
 *
 */
export const RadioGroup: React.FC<RadioGroupProps> = ({
  legend,
  label,
  helperText,
  error,
  name,
  row,
  children,
  sx: formControlStyles,
  required = false,
  ...props
}: RadioGroupProps) => {
  const sx: FormControlProps['sx'] = Object.assign({}, formControlStyles, {
    display: 'flex',
    flexDirection: row ? 'row' : 'column',
    justifyContent: 'space-between',
  });

  return (
    <MaterialFormControl component="fieldset" sx={sx}>
      {legend ? (
        <FormLabel component="span" required={required}>
          {legend}
        </FormLabel>
      ) : null}
      <MaterialRadioGroup row={row} aria-label={label} name={name} {...props}>
        {children}
      </MaterialRadioGroup>
      {!!helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </MaterialFormControl>
  );
};

export const Radio: React.FC<RadioProps> & { muiName: string } = ({ label, children, ...props }: RadioProps) => {
  return (
    <MaterialFormControlLabel disableTypography={true} label={label} {...props} control={children ?? props.control} />
  );
};
Radio.muiName = 'Radio';
